import { connect } from "react-redux";

import type { AccountReduxState } from "@app/modules/account";

import { EmailSection as EmailSectionComponent } from "./email-section";

const mapStateToProps = (state: AccountReduxState) => {
  const { user } = state;
  return {
    user
  };
};

export const EmailSection = connect(mapStateToProps)(EmailSectionComponent);
